module.exports = __webpack_public_path__ + "static/media/breakfastskillet.b11b1bd9.png";